var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIssueUnselected = function SvgIssueUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 .25a.75.75 0 0 1 .75.75v1.085l1.74-.348a6.983 6.983 0 0 1 4.962.86 5.483 5.483 0 0 0 5.273.202l.94-.47A.75.75 0 0 1 15.75 3v10a.75.75 0 0 1-.415.67l-.94.47a6.983 6.983 0 0 1-6.715-.257 5.483 5.483 0 0 0-3.896-.675l-2.034.407V21a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 1 .25Zm.75 11.835 1.74-.348a6.983 6.983 0 0 1 4.962.86 5.483 5.483 0 0 0 5.273.202l.525-.262V4.21a6.983 6.983 0 0 1-6.57-.328 5.483 5.483 0 0 0-3.896-.675l-2.034.407v8.47Z",
    fill: "#050400"
  })));
};
export default SvgIssueUnselected;